import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { ENTNAMES } from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'

const _ListView = ({ store }) => {
  if (!store.hasRight(ENTNAMES.ARCHIVE)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => {
          store.goTo(linkConst.LINK_ARCHIVE_DETAIL, { entityname: row.entity, id: row.id })
        }}>{linkConst.LINKS_LIST[text] || linkConst.ARCHIVE_LINKS_TITLES[text] || text}</a>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    }
  ]

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    entity: {
      title: 'entity',
      component: (props) => (<SelectInput
        {...props}
        optionsrecord={store.options}
        labelattr='label'
        valueattr='value'
        optionsattr={'entityname'} />)
    }
  }

  return (
    <ListView store={store.cv} fields={fields} filters={() => Filters(store, filters)} />
  )
}

_ListView.propTypes = {
  store: PropTypes.object.isRequired
}

export default observer(_ListView)
